import { render, staticRenderFns } from "./Content_es.vue?vue&type=template&id=7b6e1f4f&scoped=true&"
import script from "./Content_es.vue?vue&type=script&lang=js&"
export * from "./Content_es.vue?vue&type=script&lang=js&"
import style0 from "./Content_es.vue?vue&type=style&index=0&id=7b6e1f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e1f4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
